const iconEnga = document.querySelector('.icon-enga')
const openEngaCont = document.querySelector(".colapsible-enga")
const openEngatTrigger = document.querySelector(".open-colaps-enga")
openEngatTrigger.addEventListener('click', addClassEnga)

function addClassEnga() {
  if (openEngaCont.style.height === '0px') {
        const fullHeight = openEngaCont.scrollHeight + 'px'; // Get the actual height of the content
        openEngaCont.style.height = fullHeight;
    } else {
        openEngaCont.style.height = '0px';
    };
  iconEnga.classList.toggle('rot0');
}